<template>
  <v-select
    ref="select"
    dense
    hide-details
    :menu-props="{ offsetY: true }"
    :items="selectOptions"
    :no-data-text="'no options available'"
    :multiple="isMultiple"
    v-model="selectValue"
    @focus="focused = true"
    @blur="focused = false"
    @change="apply()"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip x-small v-if="index === 0">
        <span>{{ item.text }}</span>
      </v-chip>
      <span
        v-if="index === 1"
        class="grey--text caption"
      >
        (+{{ value.length - 1 }} others)
      </span>
    </template>
    <template v-if="!focused" v-slot:append-outer>
      <v-icon
        class="pointer"
        :color="!clearIconHovered ? 'green' : 'red'"
        v-if="showClearIcon"
        @mouseenter="clearIconHovered = true"
        @mouseleave="clearIconHovered = false"
        @click="clear()"
      >mdi-filter-remove</v-icon>
    </template>
  </v-select>
</template>
<script>
import simpleFilterMixin from '@/components/data-table-filters/filters/simple-filter-mixin'
export default {
  name: 'FilterSelect',
  mixins: [simpleFilterMixin],
  computed: {
    selectOptions () {
      return Array.isArray(this.filter.options) ? this.filter.options : []
    },
    selectValue: {
      get () {
        if (this.isMultiple) return this.internalMultipleValueAsArray
        if (this.filter?.dataType !== Boolean) return this.internalValue
        if (['true', 'false'].includes(this.internalValue)) return { true: true, false: false }[this.internalValue]
        return null
      },
      set (val) {
        this.internalValue = !this.isMultiple ? `${val}` : val.join(this.options.multipleValueFilterValuesDelimiter)
        this.$refs.select.blur()
      }
    }
  }
}
</script>
